export const MAX_MOBILE_WIDTH_IN_PX = 1023;
export const GREETING_DURATION_IN_MS = 6000;
export const MIN_WIDTH_MAIN_NAVIGATION_IN_PX = 320;
export const HORIZONTAL_DISTANCE_NAV_ITEMS_VIEWPORT = '4rem';
